// Load Google Fonts dynamically
const loadedFonts = new Set();

export function loadFonts(fonts) {
  const fontFamilies = Object.values(fonts)
    .filter(Boolean)
    .map((font) => font.replace(/ /g, '+'))
    .join('&family=');

  const fontKey = fontFamilies;

  if (loadedFonts.has(fontKey)) {
    return; // Already loaded
  }

  const link = document.createElement('link');
  link.href = `https://fonts.googleapis.com/css2?family=${fontFamilies}&display=swap`;
  link.rel = 'stylesheet';
  document.head.appendChild(link);

  loadedFonts.add(fontKey);
}

// Apply template theme to document root
export function applyTemplate(templateDef) {
  if (!templateDef) return;

  const root = document.documentElement;

  // Inject color variables
  if (templateDef.theme?.colors) {
    Object.entries(templateDef.theme.colors).forEach(([key, value]) => {
      root.style.setProperty(`--color-${key}`, value);
    });
  }

  // Load and apply fonts
  if (templateDef.theme?.fonts) {
    loadFonts(templateDef.theme.fonts);

    // Apply font family variables
    Object.entries(templateDef.theme.fonts).forEach(([key, value]) => {
      root.style.setProperty(`--font-${key}`, value);
    });
  }
}

// Remove template theme (revert to default)
export function removeTemplate() {
  const root = document.documentElement;

  // Reset to default values would require storing defaults
  // For now, we'll just let the next template override
  console.log('Template removed');
}
